import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from "nuqs";
import { WorkOrderStatusSchema } from "@myapp/contract";
import {
  INITIAL_WORK_ORDER_FILTERS,
  WorkOrderFiltersForm,
} from "./workOrderFilters.types";

const SORT_FIELDS = new Set<WorkOrderFiltersForm["sortField"]>([
  "workOrderId",
  "mieter",
  "handwerker",
  "datum",
  "ve",
  "hauseingang",
  "wohnung",
]);

const SORT_DIRECTIONS = new Set<WorkOrderFiltersForm["sortDirection"]>([
  "ASC",
  "DESC",
]);

export const useWorkOrderFiltersParams = () =>
  useQueryStates(
    {
      workOrderId: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.workOrderId),
      mieter: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.mieter),
      handwerker: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.handwerker),
      datum: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.datum),
      wohnung: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.wohnung),
      hauseingang: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.hauseingang),
      ve: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.ve),
      sortField: parseAsString.withDefault(INITIAL_WORK_ORDER_FILTERS.sortField),
      sortDirection: parseAsString.withDefault(
        INITIAL_WORK_ORDER_FILTERS.sortDirection,
      ),
      status: parseAsStringLiteral(WorkOrderStatusSchema.options),
      gewerkId: parseAsInteger,
    },
    {
      clearOnDefault: true,
    },
  );

export type WorkOrderFiltersParams = ReturnType<
  typeof useWorkOrderFiltersParams
>[0];

export const toWorkOrderFiltersForm = (
  params: WorkOrderFiltersParams,
): WorkOrderFiltersForm => ({
  workOrderId: params.workOrderId,
  mieter: params.mieter,
  handwerker: params.handwerker,
  datum: params.datum,
  wohnung: params.wohnung,
  hauseingang: params.hauseingang,
  ve: params.ve,
  status: params.status,
  gewerkId: params.gewerkId,
  sortField: SORT_FIELDS.has(params.sortField as WorkOrderFiltersForm["sortField"])
    ? (params.sortField as WorkOrderFiltersForm["sortField"])
    : INITIAL_WORK_ORDER_FILTERS.sortField,
  sortDirection: SORT_DIRECTIONS.has(
    params.sortDirection as WorkOrderFiltersForm["sortDirection"],
  )
    ? (params.sortDirection as WorkOrderFiltersForm["sortDirection"])
    : INITIAL_WORK_ORDER_FILTERS.sortDirection,
});
